import { render, staticRenderFns } from "./UnitGroupsWidget.vue?vue&type=template&id=5fec4ddc&scoped=true"
import script from "./UnitGroupsWidget.vue?vue&type=script&lang=js"
export * from "./UnitGroupsWidget.vue?vue&type=script&lang=js"
import style0 from "./UnitGroupsWidget.vue?vue&type=style&index=0&id=5fec4ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fec4ddc",
  null
  
)

export default component.exports